import {
   HttpCodes,
   INVALID_WEARABLE_VITAL_READING_CODE,
} from "@/constants/globals"
import { get } from "@/utils/lodash"

export function isConditionError(error: unknown): boolean {
   return get(error, "name") === "ConditionError"
}

export function handleInvalidVitalValue(value: number | null): number | null {
   return value === INVALID_WEARABLE_VITAL_READING_CODE ? null : value
}

export function getEntraErrorMessage(
   status?: number,
   message?: string
): string {
   if (message) {
      return message
   }
   if (!status) {
      return "Could not reach the server. Please try again."
   }
   switch (status) {
      case HttpCodes.BAD_REQUEST:
         return "Could not complete the Entra login."
      case HttpCodes.SERVICE_UNAVAILABLE:
         return "Entra SSO is not configured."
      default:
         return "Authentication failed."
   }
}
